/** @file pivotWarnings: PIVOT_OUTSIDE when an entry's pivot lies outside its tile (one warning per drawable). */
import type { Drawable } from '@zilo/pose3d-format/types/drawable';
import type { Warning } from '@zilo/pose3d-format/types/warning';

const outside = (v: number): boolean => v < 0 || v > 1;

/** One `PIVOT_OUTSIDE` at `/puppet/drawables/<index>` naming the entries whose `pivotFrac` leaves [0, 1]. */
export function pivotWarnings(drawable: Drawable, index: number): Warning[] {
  const facets = drawable.kind === 'impostor' || drawable.kind === 'effect' ? (drawable.facets ?? []) : [];
  const entries = facets.flatMap((e, i) => (outside(e.pivotFrac[0]) || outside(e.pivotFrac[1]) ? [i] : []));
  if (entries.length === 0) return [];
  return [{
    code: 'PIVOT_OUTSIDE', path: `/puppet/drawables/${index}`, params: { drawable: drawable.id, entries },
    message: `drawable ${drawable.id} has a pivot outside its tile (entries ${entries.join(', ')})`,
    hint: 'facet.setEntry pivotFrac within [0, 1], unless the image really hangs off its node',
  }];
}
